<template>
  <div>
    <!-- 搜索区 -->
    <el-form :model="searchData" ref="search">
      <QS-search maxLine="2" ref="BLM-search">
        <el-form-item prop="bizName" label="审批流名称">
          <el-select
            v-model="searchData.bizName"
            filterable
            clearable
            remote
            placeholder="请输入"
            :remote-method="loadBizNameData"
            :loading="oLoading.fuzzySearch"
            @visible-change="resetSelectOptions"
          >
            <el-option
              v-for="item in bizNameOptions"
              :key="item.bizType"
              :label="item.bizName"
              :value="item.bizName"
            >
              {{ item.bizName }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="deptIdList" label="部门名称">
          <DeptSelect v-model="searchData.deptIdList" filterable clearable multiple />
        </el-form-item>
        <el-form-item prop="organizationId" label="钉钉组织">
          <el-select
            v-model="searchData.organizationId"
            filterable
            clearable
            remote
            placeholder="请输入"
            :remote-method="loadOrgNameData"
            :loading="oLoading.fuzzy"
            @visible-change="resetSelectOptions"
          >
            <el-option
              v-for="item in orgNameOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="open" label="状态">
          <el-select v-model="searchData.open" clearable placeholder="请选择">
            <el-option
              v-for="item in stateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <template slot="moreBtn">
          <el-form-item>
            <el-button
              :loading="oLoading.search"
              type="primary"
              @click="handleSearch"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
          <el-form-item v-if="isShowExport">
            <export
              exportTemplate="ApprovalList"
              filename="审批流配置.xlsx"
              :params="searchData"
              text="导出配置"
              type="primary"
            ></export>
          </el-form-item>
        </template>
      </QS-search>
    </el-form>
    <div>
      <el-button
        v-if="isShowChangeApprovaler"
        type="primary"
        @click="batchReplaceApprovaler"
        >批量更换审批人</el-button
      >
      <BatchReplaceApprovaler
        :show.sync="dialogVisible"
        :groupType="groupType"
      />
    </div>

    <!-- 分类项 折叠面板 -->
    <el-collapse v-model="activeTabNames" @change="handleTabCollapse">
      <el-collapse-item
        v-for="item in tabs"
        :title="item.bizName"
        :name="item.bizType"
        :key="item.bizType"
      >
        <QS-common-table
          :data="item.tableData"
          :columns="columns"
          :pagination="item.paginationData"
          @change="(payload) => paginationChange(payload, item)"
        >
        </QS-common-table>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import {
  getApprovalTemplateList, // 获取table中的数据接口
  updateStatus,
  approvalTasktaskGet,
  getDingtalkOrganizationList, // 获取 钉钉组织接口
  getBizTypeList, // 获取审批类型
  checkOpenState,
} from '@/api/domain/approvals'
import DeptSelect from '@/components/DeptSelect'
import BatchReplaceApprovaler from './components/batchReplaceApprovaler.vue'
import {
  stateOptions,
  columnsCom,
  paginationData,
} from './config.js'
import { operateMaxShowLength } from '@/store/dict/config'

const searchData = {
  groupType: '',
  deptIdList: [], // 部门ID
  organizationId: '', // 组织ID
  bizName: '', // 审批业务类型
  open: '', // 开启状态 0:关闭，1:开启
}

export default {
  name: 'approvalConfig',
  components: {
    BatchReplaceApprovaler,
    DeptSelect,
  },
  props: {
    // 业务类型
    groupType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogVisible: false,
      activeTabNames: [], // 开启的分类tab
      oriActiveTabNames: new Set(), // 开启的分类tab
      orgNameOptions: [], // 钉钉组织模糊搜索下拉选项
      bizNameOptions: [], // 审批名称模糊搜索下拉选项
      stateOptions, // 状态 options
      tabs: [],
      searchData: { ...searchData }, // 搜索参数
      searchFormData: { ...searchData },
      oLoading: {
        fuzzySearch: false, // 模糊搜索
        search: false, // 搜索
        fuzzy: false, //
      },
      formName: 'search', // 表单ref
    }
  },
  computed: {
    isShowExport() {
      return this.judgePermission('tenant_approval_flow_export')
    },
    isShowChangeApprovaler() {
      return this.judgePermission('tenant_approval_flow_replace_approver')
    },
    columns() {
      const { columns } = columnsCom.call(this)
      // 集团下  添加 公司
      columns.unshift({
        name: 'deptName',
        columnProps: {
          label: '部门',
          prop: 'deptName',
        },
      })

      columns.push({
        name: 'operate',
        columnProps: {
          label: '操作',
          width: 240,
          fixed: 'right',
        },
        maxShowLength: operateMaxShowLength,
        getOperateList: ({ row }) => {
          const optBtns = []
          // 集团按钮
          if (this.judgePermission('tenant_new_approval_config_list_detail')) {
            optBtns.push({
              name: 'detail',
              label: '详情',
              action: () => this.detailHandle(row),
            })
          }

          if (this.judgePermission('tenant_new_approval_config_list_edit')) {
            optBtns.push({
              name: 'edit',
              label: '编辑',
              action: () => this.editHandle(row),
            })
          }
          if (
            this.judgePermission(
              'tenant_new_approval_config_list_enable_and_disable',
            )
          ) {
            const statusText = row.open ? '停用' : '启用'
            optBtns.push({
              name: 'status',
              label: statusText,
              action: () => this.statusHandle(row),
            })
          }

          return optBtns
        },
        type: 'operate',
      })
      return columns
    },
  },
  async mounted() {
    this.getTabs()
  },
  methods: {
    async batchReplaceApprovaler() {
      checkOpenState().then((res) => {
        if (res.code === 1) {
          this.dialogVisible = true
        }
      })
    },
    findCurrentTab(bizType) {
      return this.tabs.find((x) => x.bizType === bizType)
    },
    /** 获取 折叠分类项 tabs */
    async getTabs(bizName) {
      const params = {
        type: 'approveType',
        groupType: this.groupType,
      }
      // 如果 搜索内容中含有 bizName
      if (bizName) {
        params.bizName = bizName
      }
      this.tabs = []
      const { data, code } = await getBizTypeList(params)
      // const { data, code } = await getEnum(params)
      if (code !== 1 || !data || !Array.isArray(data)) return
      // 需要包装tabs 将分类下的table基本参数存储到tabs下
      this.transferTabsInTable(data)
    },
    // 获取表格列表数据
    async getList(currentTab) {
      this.oLoading.search = true
      const params = {
        ...this.searchFormData,
        bizType: '',
        groupType: this.groupType,
        pageSize: currentTab.paginationData.pageSize,
        pageNum: currentTab.paginationData.pageNum,
      }

      // 集团的话 需要单独处理下 bizType 字段
      if (currentTab.bizType) {
        params.bizType = Number(currentTab.bizType)
      }

      const { code, data } = await getApprovalTemplateList(params)
      this.oLoading.search = false
      if (code === 1) {
        currentTab.tableData = (data && data.items) || []
        currentTab.paginationData.total = data.totalNum
        this.tabs = this.tabs.map((item) => {
          return item.bizType === currentTab.bizType
            ? { ...currentTab, firstFlag: false }
            : item
        })
      }
    },
    /** 将每个tab 注入table的基本参数  */
    transferTabsInTable(data = []) {
      // 收起tabs
      this.activeTabNames = []
      this.oriActiveTabNames = new Set()
      // tabs 赋值
      this.tabs = data.map((item) => {
        // 存在分页属性 那就只需要重置空 paginationData.pageNum
        item.paginationData = { ...paginationData, pageNum: 1 }
        // 重置空当前tab下的tableData
        item.tableData = []
        // 是否是刷新
        item.firstFlag = true
        return item
      })
    },
    /** 处理分类折叠开启的问题 */
    handleTabCollapse(val) {
      // 为空是关闭  数组为有值['1', 2,3,3,]
      const _arr = [...val].filter((item) => !this.oriActiveTabNames.has(item))
      // 为空是收起 所以不用处理
      // 如果差集有值 且 唯一 那就是
      let tItem
      // 重新获取当前
      _arr.length === 1 && (tItem = this.findCurrentTab(_arr[0]))
      if (tItem && tItem.firstFlag) {
        // 重新拉取数据
        this.getList(tItem)
      }

      this.oriActiveTabNames = new Set([...val])
    },
    getToLinkParams(row) {
      const { id, organizationId, bizType, deptId } = row
      // id:钉钉组织主键id，organizationId：钉钉组织id，bizType：钉钉组织模版类型
      const params = {
        id,
        organizationId,
        bizType,
        deptId,
      }
      return params
    },
    // 详情
    detailHandle(row) {
      const query = this.getToLinkParams(row)
      this.$router.push({
        path: '/tenant/groupApproveFlowConfig/detail',
        query,
      })
    },
    // 编辑
    editHandle(row) {
      const query = this.getToLinkParams(row)
      this.$router.push({
        path: '/tenant/groupApproveFlowConfig/edit',
        query,
      })
    },
    // 开启、停用
    statusHandle(row) {
      const msg = row.open ? '停用' : '启用'
      const open = row.open ? 0 : 1
      this.confirmFn(msg, {
        id: row.id,
        open,
        bizType: row.bizType,
        deptIdList: [row.deptId],
      })
    },
    async confirmFn(msg, params) {
      let title = '审批'
      let content = `确定${msg}吗?`
      // 停用时检验 是否有未完成的审批
      if (!params.open) {
        const { bizType, deptIdList } = params
        approvalTasktaskGet({
          bizType,
          deptIdList,
        }).then(({ code, data }) => {
          if (code === 1 && data) {
            content = '该审批流程下有未完成的审批，是否仍要停用'
            title = '提示'
          }
          this.selfConfim(params, content, title)
        })
        return
      }
      this.selfConfim(params, content, title)
    },
    selfConfim(params, content, title) {
      this.$confirm(content, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.updateStatus(params, params.bizType)
      }).catch()
    },
    // 更新状态、下放、回收
    async updateStatus(params, bizType) {
      const { code } = await updateStatus(params)
      if (code === 1) {
        this.$message.success('操作成功')
        this.getList(this.findCurrentTab(bizType))
      }
    },
    /** 处理搜索事件 */
    handleSearch() {
      // 判断是否是 审批流名称
      this.searchData.bizName !== this.searchFormData.bizName
        ? this.getTabs(this.searchData.bizName) // 1. 变更 获取当前的 tabs
        : this.transferTabsInTable(this.tabs) // 2. 否则 重置 tabs中的page和table

      // 存 本次请求参数
      this.searchFormData = { ...this.searchData }
    },
    /** 切换页码 */
    paginationChange(payload, currentTab) {
      const { pagination } = payload
      // 集团
      currentTab.paginationData.pageSize = pagination.pageSize
      currentTab.paginationData.pageNum = pagination.pageNum
      this.getList(currentTab)
    },
    /** 清空表单 搜索 */
    reset() {
      this.$refs[this.formName].resetFields()
      this.searchData = { ...searchData }
      this.searchFormData = {}
      this.handleSearch()
    },
    // 远程搜索 审批流名称
    async loadBizNameData(queryStr) {
      // 未填写任何内容， 清空选项
      if (!queryStr.toString()) {
        this.bizNameOptions = []
        return
      }
      // 有填写参数 异步请求
      this.oLoading.fuzzySearch = true
      const params = {
        groupType: this.groupType,
        bizName: queryStr,
      }
      const { code, data } = await getBizTypeList(params) // 这里有问题
      this.oLoading.fuzzySearch = false
      if (code !== 1) return
      this.bizNameOptions = data.filter(
        (item) => item.bizName.indexOf(queryStr) > -1,
      )
    },
    /** 远程搜索钉钉组织 */
    async loadOrgNameData(queryStr) {
      // 未填写任何内容， 清空选项
      if (!queryStr.toString()) {
        this.orgNameOptions = []
        return
      }
      // 有填写参数 异步请求
      this.oLoading.fuzzySearch = true
      const { code, data } = await getDingtalkOrganizationList() // 这里有问题
      this.oLoading.fuzzySearch = false
      if (code !== 1) return
      // 过滤参数
      this.orgNameOptions = data.filter(
        (item) => item.name && item.name.indexOf(queryStr) > -1,
      )
    },
    /** 模糊搜索 清空options */
    resetSelectOptions(e) {
      if (!e) {
        this.orgNameOptions = []
        this.bizNameOptions = []
      }
    },
  },
}
</script>

<style>
.el-collapse-item__content {
  padding: 0;
}
</style>
